import { Row } from "@/components";

export const ChangedFieldsRow = ({
  label,
  oldValue,
  newValue,
}: {
  label: string;
  oldValue: string;
  newValue: string;
}) => {
  return (
    <Row className="items-center gap-2 text-sm">
      <span className="text-slate-500">{label}:</span>
      <span className="text-slate-400 line-through">{oldValue}</span>
      <span className="text-slate-500">→</span>
      <span className="font-medium text-slate-700">{newValue}</span>
    </Row>
  );
};
